var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllhelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_2_16)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9377 27.1711C32.6158 27.1661 33.2509 27.503 33.627 28.0673L44.3613 44.1686C44.9778 45.0935 44.7279 46.3431 43.8031 46.9597C42.8782 47.5763 41.6286 47.3264 41.012 46.4015L31.9791 32.8522L25.2493 43.2724H31.6169C32.7285 43.2724 33.6296 44.1735 33.6296 45.2851C33.6296 46.3966 32.7285 47.2977 31.6169 47.2977H21.5536C20.8166 47.2977 20.1385 46.8949 19.786 46.2477C19.4335 45.6004 19.463 44.8123 19.8628 44.1931L30.2616 28.0918C30.6296 27.5221 31.2596 27.176 31.9377 27.1711Z",
    fill: "#FDFEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.592 31.0734C41.5169 30.4569 42.7665 30.7068 43.3831 31.6317L51.7411 44.1686C52.3577 45.0935 52.1077 46.3431 51.1829 46.9597C50.258 47.5763 49.0084 47.3264 48.3918 46.4015L40.0338 33.8645C39.4172 32.9396 39.6671 31.69 40.592 31.0734Z",
    fill: "#FDFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3947 34.7077C51.3196 34.0912 52.5692 34.3411 53.1858 35.266L59.1209 44.1686C59.7375 45.0935 59.4875 46.3431 58.5627 46.9597C57.6378 47.5763 56.3882 47.3264 55.7716 46.4015L49.8365 37.4988C49.2199 36.5739 49.4698 35.3243 50.3947 34.7077Z",
    fill: "#FDFEFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_16",
    x1: 17.525,
    y1: 72.0894,
    x2: 66.5639,
    y2: 10.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C70FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllhelp);
export default __webpack_public_path__ + "static/media/allhelp.9520de1362d0afb0998771ddc63270a9.svg";
export { ForwardRef as ReactComponent };